import React from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../data/mock';
import { Calendar, ArrowRight, Tag } from 'lucide-react';

const BlogPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      {/* Header */}
      <section className="bg-gradient-to-r from-orange-600 to-orange-700 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Notre Blog</h1>
          <p className="text-xl text-orange-200 max-w-2xl mx-auto">
            Conseils, tendances et inspirations pour vos événements
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Featured Post */}
        {blogPosts.length > 0 && (
          <div className="mb-12">
            <Link
              to={`/blog/${blogPosts[0].id}`}
              className="group block bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow"
            >
              <div className="grid md:grid-cols-2">
                <div className="aspect-[16/10] md:aspect-auto">
                  <img
                    src={blogPosts[0].image}
                    alt={blogPosts[0].title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-8 flex flex-col justify-center">
                  <span className="inline-flex items-center gap-1 text-sm text-orange-500 font-medium mb-3">
                    <Tag className="w-4 h-4" />
                    {blogPosts[0].category}
                  </span>
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 group-hover:text-orange-500 transition-colors">
                    {blogPosts[0].title}
                  </h2>
                  <p className="text-gray-600 mb-4">{blogPosts[0].excerpt}</p>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center gap-2 text-sm text-gray-500">
                      <Calendar className="w-4 h-4" />
                      {blogPosts[0].date}
                    </span>
                    <span className="flex items-center gap-1 text-orange-500 font-medium">
                      Lire l'article <ArrowRight className="w-4 h-4" />
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        )}

        {/* Other Posts */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.slice(1).map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="inline-flex items-center gap-1 text-xs text-orange-500 font-medium mb-2">
                  <Tag className="w-3 h-3" />
                  {post.category}
                </span>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors">
                  {post.title}
                </h3>
                <p className="text-sm text-gray-500 mb-4">{post.excerpt}</p>
                <span className="flex items-center gap-2 text-xs text-gray-400">
                  <Calendar className="w-3 h-3" />
                  {post.date}
                </span>
              </div>
            </Link>
          ))}
        </div>

        {blogPosts.length === 0 && (
          <div className="text-center py-16">
            <p className="text-gray-500">Aucun article pour le moment. Revenez bientôt !</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPage;
